module.exports = "<p>\n  company-dashboard-view-performance-records works!\n</p>\n"